<template>
  <span :title="title" class="title">
    <span v-html="document.referencia_bibliografica"></span>,
    {{ document.fecha_visible}}
  </span>
</template>
<script setup lang="ts">
import { map } from 'lodash-es'
import { useContextFields } from './context_fields'
import { computed } from 'vue'

const props = defineProps<{
  document: Record<string, any>,
  text: Record<string, any>,
  elements: Record<string, any>,
  matches: number[]
}>()

const contextFields = useContextFields(props.document, props.text, props.elements, props.matches)

const title = computed(() => map(contextFields, (v, k) => `${k}: ${v || ''}`).join('\n'))
</script>
